module.exports = __webpack_public_path__ + "static/img/xmtdyy.5c94cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT003/xmtdyy.png
// module id = gsVq
// module chunks = 1